import AxiosInstance from 'src/shared/services/axios/interceptor';
import { MemberUpdateRespons } from 'src/modules/member/models/memberUpdateRespons';
import { PagedResult } from 'src/shared/models/pagedResult';
import { MemberUpdateRequest } from 'src/modules/member/models/memberUpdateRequest';
import { setPagingParams } from 'src/shared/functions/createPagingParams';

const controller = 'MemberUpdate';

export const getMemberUpdate = (pageIndex: number, pageSize: number, sortCol: string, sortDir: string) => {
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<MemberUpdateRespons>>(endpoint);
};

export const getMemberUpdateByMemberId = (memberUpdateId) => {
  const endpoint = `${controller}/${memberUpdateId}`;
  return AxiosInstance.get<MemberUpdateRespons>(endpoint);
};

// Bara id:na för de väntande uppdateringarna. Används av Godkänn alla, där listan kan vara
// tiotusentals rader och de fullständiga svaren skulle kosta ett medlemsuppslag per rad.
export const getPendingMemberUpdateIds = () => {
  return AxiosInstance.get<number[]>(`${controller}/PendingIds`);
};

export const createMemberUpdate = (memberUpdates: MemberUpdateRequest[]) => {
  const endpoint = `${controller}/Set`;
  return AxiosInstance.put<MemberUpdateRespons>(endpoint, memberUpdates);
};
